import { useState } from "react";
import { NavLink, Outlet, Link } from "react-router-dom";
import { CalendarRange, Music, FolderTree, Users, Images, PartyPopper, Settings, LogOut, ExternalLink, Menu } from "lucide-react";
import { Sheet, SheetContent, SheetTrigger, SheetTitle } from "@/components/ui/sheet";
import { useAuth } from "@/context/AuthContext";
import { Logo } from "@/components/site/Logo";

const LINKS = [
  { to: "/yonetim", label: "Randevular", icon: CalendarRange, end: true },
  { to: "/yonetim/kurslar", label: "Kurslar", icon: Music },
  { to: "/yonetim/kategoriler", label: "Kategoriler", icon: FolderTree },
  { to: "/yonetim/ogretmenler", label: "Öğretmenler", icon: Users },
  { to: "/yonetim/galeri", label: "Galeri", icon: Images },
  { to: "/yonetim/etkinlikler", label: "Etkinlikler", icon: PartyPopper },
  { to: "/yonetim/ayarlar", label: "Ayarlar", icon: Settings },
];

function NavItems({ onNavigate }) {
  const { logout } = useAuth();
  const cls = ({ isActive }) =>
    `flex items-center gap-3 rounded-xl px-4 py-2.5 text-sm font-bold transition-colors ${isActive ? "bg-white text-navy" : "text-white/80 hover:bg-white/10 hover:text-white"}`;
  return (
    <div className="flex flex-col gap-1">
      {LINKS.map((l) => (
        <NavLink key={l.to} to={l.to} end={l.end} className={cls} onClick={onNavigate} data-testid={`admin-nav-${l.to.split("/")[2] || "randevular"}`}>
          <l.icon className="w-4 h-4" /> {l.label}
        </NavLink>
      ))}
      <div className="my-4 border-t border-white/10" />
      <Link to="/" target="_blank" className="flex items-center gap-3 rounded-xl px-4 py-2.5 text-sm font-bold text-white/70 hover:text-white" data-testid="admin-view-site">
        <ExternalLink className="w-4 h-4" /> Siteyi gör
      </Link>
      <button onClick={logout} className="flex items-center gap-3 rounded-xl px-4 py-2.5 text-sm font-bold text-white/70 hover:text-white text-left" data-testid="admin-logout-btn">
        <LogOut className="w-4 h-4" /> Çıkış yap
      </button>
    </div>
  );
}

export function AdminLayout() {
  const [open, setOpen] = useState(false);
  return (
    <div className="min-h-screen bg-cream lg:flex">
      <aside className="hidden lg:flex lg:flex-col w-64 shrink-0 bg-navy p-5 sticky top-0 h-screen">
        <div className="mb-8 px-2"><Logo light to="/yonetim" /></div>
        <NavItems />
      </aside>
      <div className="lg:hidden sticky top-0 z-30 flex items-center justify-between bg-navy px-4 h-16">
        <Logo light to="/yonetim" />
        <Sheet open={open} onOpenChange={setOpen}>
          <SheetTrigger asChild>
            <button className="p-2 rounded-full bg-white/10 text-white" data-testid="admin-mobile-menu-btn" aria-label="Menü"><Menu className="w-5 h-5" /></button>
          </SheetTrigger>
          <SheetContent side="left" className="bg-navy border-none w-72">
            <SheetTitle className="sr-only">Yönetim menüsü</SheetTitle>
            <div className="mt-8"><NavItems onNavigate={() => setOpen(false)} /></div>
          </SheetContent>
        </Sheet>
      </div>
      <main className="flex-1 min-w-0 p-4 sm:p-6 lg:p-8">
        <Outlet />
      </main>
    </div>
  );
}

export const AdminTitle = ({ title, children }) => (
  <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4 mb-6">
    <h1 className="font-heading text-2xl sm:text-3xl font-black text-navy" data-testid="admin-page-title">{title}</h1>
    {children && <div className="flex flex-wrap gap-2">{children}</div>}
  </div>
);
